import React from 'react'
import { ListGroupItem, Card, CardHeader, CardBody, ListGroup, } from 'reactstrap'
import forOwn from 'mout/object/forOwn'
import sortByPropText from '../../helpers/content/manageSets/sortByPropText'
import { DistrictsFilter } from './'

/*
ManageEducators: 

  <DistrictsCard 
    districts={this.props.districts}
    selectedDistrict={this.props.selection.district}
    key='DistrictsCard'
    openModal={this.props.openModal}
    select={this.props.select}
    setForceDistrictExpanded={this.props.setForceDistrictExpanded}
    forceDistrictExpanded={this.props.forceDistrictExpanded}
    districtNameSearch={this.props.districtNameSearch}
    districtStateFilter={this.props.filters.districtState}
    setFilter={this.props.setFilter}
    setSearch={this.props.setSearch}
  />

*/

export default function DistrictsCard ({
    districts, selectedDistrict, openModal, select, setForceExpanded, forceDistrictExpanded,
    districtNameSearch, districtStateFilter, setFilter, setSearch, permissionSuper
  }) {
  let filterBar = null

  if ((!selectedDistrict || forceDistrictExpanded) && permissionSuper) {
    filterBar = (
      <DistrictsFilter 
        districtNameSearch={districtNameSearch}
        districtStateFilter={districtStateFilter}
        setFilter={setFilter}
        setSearch={setSearch}
      />
    )
  }
  
  let listGroupItems = []

  if ((!selectedDistrict || forceDistrictExpanded) && permissionSuper) {
    listGroupItems.push(
      <ListGroupItem
        key='districtListGroupItemAdd'
        onClick={() => openModal('addDistrict')}
        className='m2clickable'
      >
        + Add District
      </ListGroupItem>
    )
  }

  let districtsArray = []
  forOwn(districts, (district) => {
    if (!district.deleted) {
      districtsArray.push(district)
    }
  })
  const sortedDistricts = sortByPropText(districtsArray, 'name')
  sortedDistricts.forEach((district) => {
    const active = district.id === selectedDistrict
    if (!selectedDistrict || forceDistrictExpanded || active) {
      const districtMatch = !districtStateFilter || districtStateFilter === district.state
      const searchMatch = (
        !districtNameSearch || 
        district.name.toLowerCase().search(districtNameSearch.toLowerCase()) !== -1
      )

      if (active || (districtMatch && searchMatch)) {
        listGroupItems.push(
          <ListGroupItem 
            key={`districtListGroupItem${district.id}`}
            active={active}
            className={permissionSuper ? 'm2clickable' : ''}
            onClick={
              active && permissionSuper 
              ? () => openModal(`record&id=${district.id}`) 
              : permissionSuper ? () => select(district.id) : null}
          >
            {`${district.name}, ${district.state}`}
            {active && permissionSuper ? <i className="icon-magnifier icons ml-2"></i> : null}
          </ListGroupItem>
        )
      }
    }
  })

  let icon = (
    <i 
      className="fa fa-minus-circle float-right m2clickable"
      onClick={() => setForceExpanded('forceDistrictExpanded', false)}  
    ></i>
  )
  if (selectedDistrict && !forceDistrictExpanded) {
     icon = (
      <i 
        className="fa fa-plus-circle float-right m2clickable" 
        onClick={() => setForceExpanded('forceDistrictExpanded', true)}
      ></i>
    ) 
  } else if (!forceDistrictExpanded) {
    icon = <i className='fa fa-circle float-right'></i>
  }
  if (!permissionSuper) {
    icon = null
  }


  
  return (
    <Card>
      <CardHeader>
        {icon} Districts
      </CardHeader>
      <CardBody>
        {filterBar}
        <ListGroup className='m2scroll'>
          {listGroupItems}
        </ListGroup>
      </CardBody>
    </Card>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/DistrictsCard.js